import React from 'react'
import { graphql } from 'gatsby'
import CommunitySuccessStories, {
  CommunitySuccessStoriesContent,
  CommunitySuccessStoryCard,
} from 'src/components/organisms/general/communitySuccessStories'

// NOTE: Replace this local type with `PrismicPageDataBodyCommunitySuccessStories`
// from 'src/typings/generated/graphql' after the slice is added to the Prismic
// Custom Type and `npm run type-graphql` is run.
type PrismicPageDataBodyCommunitySuccessStories = {
  primary: {
    anchor?: string | null
    headline?: string | null
    cta_headline?: string | null
    primary_button_text?: string | null
    primary_button_variant?: string | null
    primary_button_link?: any
    secondary_button_text?: string | null
    secondary_button_link?: any
    modal_title?: string | null
    modal_option_1_label?: string | null
    modal_option_1_link?: any
    modal_option_2_label?: string | null
    modal_option_2_link?: any
    modal_continue_text?: string | null
  }
  items?: Array<{
    card_image?: any
    card_quote?: any
    card_name?: string | null
    card_subtitle?: string | null
  }> | null
}

type Props = {
  slice: PrismicPageDataBodyCommunitySuccessStories
}

const CommunitySuccessStoriesSlice = ({ slice }: Props) => {
  const cards: CommunitySuccessStoryCard[] = (slice.items ?? []).map(item => ({
    image: item?.card_image?.gatsbyImageData ?? undefined,
    imageAlt: item?.card_image?.alt ?? undefined,
    quote: item?.card_quote?.richText?.[0]?.text ?? undefined,
    name: item?.card_name ?? undefined,
    subtitle: item?.card_subtitle ?? undefined,
  }))

  const content: CommunitySuccessStoriesContent = {
    anchor: slice.primary.anchor ?? undefined,
    headline: slice.primary.headline ?? undefined,
    cards,
    ctaHeadline: slice.primary.cta_headline ?? undefined,
    primaryButtonText: slice.primary.primary_button_text ?? undefined,
    primaryButtonVariant: slice.primary.primary_button_variant ?? undefined,
    primaryButtonLink: slice.primary.primary_button_link ?? undefined,
    secondaryButtonText: slice.primary.secondary_button_text ?? undefined,
    secondaryButtonLink: slice.primary.secondary_button_link ?? undefined,
    modal: {
      title: slice.primary.modal_title ?? '',
      option1Label: slice.primary.modal_option_1_label ?? '',
      option1Link: slice.primary.modal_option_1_link ?? undefined,
      option2Label: slice.primary.modal_option_2_label ?? '',
      option2Link: slice.primary.modal_option_2_link ?? undefined,
      continueText: slice.primary.modal_continue_text ?? 'Continue',
    },
  }

  return <CommunitySuccessStories content={content} />
}

export default CommunitySuccessStoriesSlice

export const communitySuccessStoriesFragment = graphql`
  fragment PageDataBodyCommunitySuccessStories on PrismicPageDataBodyCommunitySuccessStories {
    primary {
      anchor
      headline
      cta_headline
      primary_button_text
      primary_button_variant
      primary_button_link {
        ...BasicLinkFragment
      }
      secondary_button_text
      secondary_button_link {
        ...BasicLinkFragment
      }
      modal_title
      modal_option_1_label
      modal_option_1_link {
        ...BasicLinkFragment
      }
      modal_option_2_label
      modal_option_2_link {
        ...BasicLinkFragment
      }
      modal_continue_text
    }
    items {
      card_image {
        alt
        gatsbyImageData(layout: CONSTRAINED, width: 600)
      }
      card_quote {
        richText
      }
      card_name
      card_subtitle
    }
  }
`
